import { Navigate, useRoutes } from 'react-router-dom';
// guards
import AuthGuard from 'src/guards/AuthGuard';
import GuestGuard from 'src/guards/GuestGuard';
import DashboardLayout from '../layouts/dashboard';
// layouts
import LogoOnlyLayout from '../layouts/LogoOnlyLayout';
import { AuthInfo, Cutoff, Hypotension, Main, MyInfo, NotFound } from './elements';
// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    // Main Routes
    {
      path: '*',
      element: <LogoOnlyLayout />,
      children: [
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" replace /> },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
    {
      path: '/',
      element: (
        <GuestGuard>
          <Main />
        </GuestGuard>
      ),
    },
    {
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: 'cdss',
          children: [
            {
              path: 'hypotension',
              element: <Hypotension />,
            },
          ],
        },
        {
          path: 'management',
          children: [
            {
              path: 'my-info',
              element: <MyInfo />,
            },
            {
              path: 'auth-info',
              element: <AuthInfo />,
            },
            {
              path: 'cut-off',
              element: <Cutoff />,
            },
            {
              path: 'patient-info',
              element: <Hypotension />,
            },
          ],
        },
      ],
    },
  ]);
}

